export class RecipeTag {
    // tslint:disable-next-line: variable-name
    public rcp_id: number;
    // tslint:disable-next-line: variable-name
    public tag_id: number;
    public Groups: string;
}
